import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#082E5C] via-[#0a3a6e] to-[#082E5C]">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#00D4D8] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FFDA0C] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-[#00D4D8] rounded-full mix-blend-multiply filter blur-3xl opacity-5 animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8 text-white">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20">
              <Sparkles className="text-[#FFDA0C]" size={20} />
              <span className="text-sm font-medium">La administración del futuro</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              Tu Condominio,
              <span className="block text-[#00D4D8]">100% Digital</span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              Transformamos la administración de condominios con inteligencia artificial, automatización y tecnología de punta. Todo en un solo click.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-[#00D4D8] hover:bg-[#00B8BC] text-white text-lg px-8 py-6 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#00D4D8]/50 group"
              >
                Solicita un Diagnóstico Gratis
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={() => document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                variant="outline"
                className="text-white border-2 border-white/30 hover:bg-white/10 hover:border-white text-lg px-8 py-6 rounded-xl backdrop-blur-sm transition-all duration-300"
              >
                Conocer Más
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold text-[#FFDA0C]">100%</div>
                <div className="text-sm text-gray-300 mt-1">Digital</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#FFDA0C]">24/7</div>
                <div className="text-sm text-gray-300 mt-1">Soporte</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#FFDA0C]">+10</div>
                <div className="text-sm text-gray-300 mt-1">Años</div>
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <div className="hidden lg:flex justify-center items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-[#00D4D8] rounded-3xl blur-3xl opacity-20 animate-pulse"></div>
              <img
                src="https://customer-assets.emergentagent.com/job_condodigitalchile/artifacts/ddn74r4e_Logo%20Tu%20Condominio%20Digital%20%281%29.png"
                alt="Tu Condominio Digital"
                className="relative w-full max-w-md object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
